import { theme } from '../theme/theme';

/**
 * @deprecated Use the new theme system from `src/theme/theme.ts` instead.
 * This object will be removed in a future release.
 */
export const colors = {
	primary: theme.colors.primary, // Use theme.colors.primary instead
	secondary: '#53479E', // texts - table headers
	tertiary: '#ADA7D7', // texts - demographics field names
	hover: '#EFEDF7',
	background: '#F8F8FC', // Use theme.colors.colorBgLayout instead
	white: '#FFFFFF', // Use theme.colors.white instead
	accentOrange: '#F24E1E', // text
	accentOrangeLight: 'rgba(230, 80, 0, 0.4)', // pdfSelectedText
	accentYellowLight: 'rgba(230, 195, 0, 0.35)', // pdfSelectedCurrentText
	accentLightGreen: '#78F5CE', // Next patient button
	dark: '#1C1835', // small button
	lightGrey: '#C2BFBF', // For borders, use theme.border.colors.base instead
	docsGrey: '#FAFAFA',
	tagGray: '#FAFAFA',
	textGrey: '#686868',
	passwordIndicator: {
		// password strength indicator bar
		fine: '#ded69b',
		good: '#bede9b',
		strong: '#a3de9b',
		excellent: '#9bdea9',
		empty: '#ADA7D7',
	},
	antInfoIconColor: '#6454BF',
	authInputBackground: '#ECECFF',
	newHccGDx: '#98DEA9',
	notAddressedDx: '#D5F1DB',
	rejectedDx: '#E0E0E0',
	noHccDx: '#CDF1F9',
	cartStroke: '#F7F6FB',
	colorInfoBorder: '#72B0EA',
	colorTextDescription: 'rgba(0, 0, 0, 0.45)',
	colorIcdDocumentTitle: 'rgba(0, 0, 0, 0.65)',
	borderGrey: '#C4C4C4',
};
